import React, { useState } from "react";
import JoditEditor from "jodit-react";
import "./report.css";

const ReportBuilder = () => {
  const [selectedSection, setSelectedSection] = useState("Header");
  const [sections, setSections] = useState(["Header"]);
  const [content, setContent] = useState({
    Header: "",
    Content: "",
    Footer: "",
  });

  const addSection = (type) => {
    if (!sections.includes(type)) {
      setSections([...sections, type]);
    }
    setSelectedSection(type);
  };

  const handleContentChange = (value) => {
    setContent({ ...content, [selectedSection]: value });
  };

  return (
    <div className="flex gap-4 p-4">
      <div className="w-3/5 p-4 bg-gray-100 rounded-md max-h-[500px] overflow-y-auto">
        <h3 className="font-semibold">Report Layout</h3>
        <div className="flex gap-2 mb-4">
          <button
            onClick={() => addSection("Header")}
            className={`px-4 py-2 rounded ${
              selectedSection === "Header"
                ? "bg-blue-800 text-white"
                : "bg-blue-600 text-white"
            }`}
          >
            Add Header
          </button>
          <button
            onClick={() => addSection("Content")}
            className={`px-4 py-2 rounded ${
              selectedSection === "Content"
                ? "bg-blue-800 text-white"
                : "bg-blue-600 text-white"
            }`}
          >
            Add Content
          </button>
          <button
            onClick={() => addSection("Footer")}
            className={`px-4 py-2 rounded ${
              selectedSection === "Footer"
                ? "bg-blue-800 text-white"
                : "bg-blue-600 text-white"
            }`}
          >
            Add Footer
          </button>
        </div>

        <div className="mb-4">
          <h3 className="text-2xl font-semibold">{selectedSection}</h3>
          <JoditEditor
            value={content[selectedSection]}
            onBlur={handleContentChange}
          />
        </div>
      </div>

      <div className="w-2/5 p-4 border border-gray-300 rounded-md bg-white max-h-[500px] overflow-y-auto print:max-h-none print:overflow-visible">
        <h3 className="text-lg font-semibold mb-2 text-center">Preview</h3>
        <div className="min-h-[300px] flex flex-col justify-between">
          {sections.includes("Header") && (
            <div
              className="border-b pb-2 text-center text-gray-700 font-semibold"
              dangerouslySetInnerHTML={{ __html: content.Header }}
            />
          )}

          <div className="flex-grow py-4 text-gray-800 break-words">
            {sections.includes("Content") && (
              <div dangerouslySetInnerHTML={{ __html: content.Content }} />
            )}
          </div>

          {sections.includes("Footer") && (
            <div
              className="border-t pt-2 text-center text-gray-600 text-sm"
              dangerouslySetInnerHTML={{ __html: content.Footer }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default ReportBuilder;
